// extracted by mini-css-extract-plugin
export default {"base":"FluSurveillance_base__C3rEq","header":"FluSurveillance_header__vW-mu","content":"FluSurveillance_content__dtKMo","body":"FluSurveillance_body__lLeK1"};